export default "__VITE_ASSET__BQk3cZtW__"